import type { SelectedAsset } from '@/contexts/InvestContext';

export type InvestmentOrder = {
  type: keyof typeof INVESTMENT_ORDER_TYPES_TRANSLATE;
  asset: NonNullable<SelectedAsset>;
  amount: string;
};

export enum INVESTMENT_ORDER_TYPES_TRANSLATE {
  buy = 'Comprar',
  sell = 'Vender',
}
